export const NISL_FLORIDA_2022 = 250;
export const NISL_PIL_2023 = 84;
export const NISL_NATIONAL_2021 = 39;
export const EXECUTIVE_COACHING = 497;
